import React from 'react';
import { Award, Calendar, CheckCircle, Download } from 'lucide-react';
import { generateCertificatePDF } from '../../utils/pdfGenerator';

const Certifications = ({ data, language, translations }) => {
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || { downloadPDF: 'Descargar PDF', note: 'Nota', noteText: '', inProgress: 'En proceso', inProgressText: '', certifications: 'Certificaciones' };
  
  // Get translated certifications data
  const certificationsData = t.certificationsData || profileData.certifications;
  
  const handleDownload = async (cert) => {
    if (cert.downloadable) {
      const success = await generateCertificatePDF(cert);
      if (success) {
        // Mostrar notificación de éxito
        const notification = document.createElement('div');
        notification.textContent = '📥 Certificado descargado exitosamente';
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: var(--cyan-primary);
          color: var(--bg-primary);
          padding: 15px 20px;
          border-radius: 8px;
          z-index: 10001;
          font-family: 'Fira Code', monospace;
          font-weight: 600;
          box-shadow: 0 0 20px rgba(176, 107, 255, 0.5);
        `;
        document.body.appendChild(notification);
        setTimeout(() => document.body.removeChild(notification), 3000);
      }
    }
  };
  return (
    <div className="content-section">
      <h2 className="section-title">{t.certifications}</h2>
      <div className="section-content">
        {certificationsData.map((cert, index) => (
          <div key={cert.id || index} className="education-card">
            <div className="card-header">
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <Award size={20} color="var(--steel-dim)" />
                  <h3 className="card-title">{cert.name}</h3>
                </div>
                <p className="card-subtitle">{cert.issuer}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                  <Calendar size={16} color="var(--text-secondary)" />
                  <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{cert.date}</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <CheckCircle size={24} color="var(--cyan-primary)" />
                {cert.downloadable && (
                  <button
                    onClick={() => handleDownload(cert)}
                    style={{
                      background: 'var(--cyan-primary)',
                      color: 'var(--bg-primary)',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '10px 15px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      fontSize: '14px',
                      fontWeight: '600',
                      fontFamily: 'inherit',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'var(--text-secondary)';
                      e.currentTarget.style.boxShadow = '0 0 15px var(--cyan-glow)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'var(--cyan-primary)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <Download size={16} />
                    {t.downloadPDF}
                  </button>
                )}
              </div>
            </div>

            {cert.description && (
              <p className="card-description">{cert.description}</p>
            )}
          </div>
        ))}

        <div style={{ 
          marginTop: '30px', 
          padding: '20px', 
          background: 'var(--bg-tertiary)', 
          borderRadius: '8px',
          border: '1px solid var(--border-color)',
          borderLeft: '3px solid var(--cyan-primary)'
        }}>
          <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
            💡 <strong style={{ color: 'var(--steel-bright)' }}>{t.note}:</strong> {t.noteText}
            <br /><br />
            🎯 <strong style={{ color: 'var(--steel-bright)' }}>{t.inProgress}:</strong> {t.inProgressText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Certifications;
